module.exports = __webpack_public_path__ + "img/stand.fd5b7843.svg";